import {LabelXSmall, Stack} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {Container} from '@/modules/common/components/RegionSelect/components/Option/components/Container';
import {Name} from '@/modules/common/components/RegionSelect/components/Option/components/Name';

export const Option = (props: any) => {
  const {t} = useTranslation('general');

  const {
    isFocused,
    isSelected,
    isDisabled,
    innerRef,
    innerProps,
    selectProps,
    getStyles,
    label: {name, count, type},
  } = props;
  const {size} = selectProps;

  return (
    <Container
      ref={innerRef}
      reactSelectStyles={getStyles('option', props)}
      isFocused={isFocused}
      isSelected={isSelected}
      isDisabled={isDisabled}
      size={size}
      groupLayout={selectProps.groupLayout}
      indented={type === 'normal'}
      {...innerProps}
    >
      <Stack justifyContent="space-between" direction="row" alignItems="center">
        <Name isSelected={isSelected} isHighlighted={type === 'groupHeader'}>
          {name}
        </Name>
        {count && (
          <LabelXSmall
            color={isSelected ? 'interactionSecondary' : 'contentSecondary'}
          >
            {t('regionSelect.hotel', {count})}
          </LabelXSmall>
        )}
      </Stack>
    </Container>
  );
};
